"use strict";
(function (global) {
    class DatabaseSettingsManager {
        constructor(config) {
            this.saveUrl = null;
            this.getUrl = null;
            this.settingsIdentifier = null;
            this.settings = {};

            this.init(config);
        }

        init(config) {
            const options = new NS.Utils.OptionsResolver(config);
            this.saveUrl = options.getOption("saveUrl");
            this.getUrl = options.getOption("getUrl");
            this.settingsIdentifier = options.getOption("id");

            if (!this.settingsIdentifier) {
                throw new Error("Please set id in constructor.");
            }

            if (!this.saveUrl || !this.getUrl) {
                throw new Error("save or get url not defined - provide them in constructor.");
            }
        }

        load(successCallback, failureCallback) {
            $.ajax({
                url: this.getUrl,
                type: 'GET',
                dataType: 'json',
                data: {
                    name: this.settingsIdentifier
                },
                success: response => {
                    if (response['success']) {
                        this.settings = response['data'] === null ? {} : response['data'];
                        successCallback.call(this);
                    } else {
                        failureCallback.call(this);
                    }
                },
                error: () => {
                    this.settings = {};

                    failureCallback.call(this);
                }
            });
        }

        save() {
            $.ajax({
                url: this.saveUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    name: this.settingsIdentifier,
                    content: JSON.stringify(this.settings)
                },
                success: function (response) {
                    if (!response.success) {
                        console.error("Błąd zapisu ustawień: ", response.error);
                    }
                },
                error: function () {
                    console.error("Błąd zapisu ustawień.");
                }
            });
        }

        get(key, defaultValue) {
            let retVal = defaultValue ? defaultValue : null;

            if (this.settings[key] !== null) {
                retVal = this.settings[key];
            }

            return retVal;
        }

        set(key, value) {
            this.settings[key] = value;
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Grid = global.NS.Grid || {};
    global.NS.Grid.DatabaseSettingsManager = DatabaseSettingsManager;
})(window);
